import styled from 'styled-components'

export const List = styled.div`
  position: relative;
  padding-bottom: ${ (props) => (props.hasShadow ? '60px' : '0') };

  > * + * {
    margin-top: 10px;
  }

  &::after {
    position: absolute;
    bottom: 0;
    content: ${ (props) => (props.hasShadow ? '""' : 'none') };
    display: block;
    width: 100%;
    height: 230px;
    background-image: linear-gradient(
      to bottom,
      rgba(237, 239, 239, 0),
      rgba(237, 239, 239, 0.5) 17%,
      #edefef 70%
    );
  }
`
